<template>
  <div class="sb-navigation">
    <div class="position-relative py-3">
      <div
        v-for="(lv1_info, lv1_idx) in toc_list"
        :key="'toc_lv1_' + lv1_idx"
        class="navigation-group"
      >
        <div :class="['d-flex align-items-center mb-3 pl-3', { 'mt-4': lv1_idx !== 0 }]">
          <h5
            class="nav-title nav-title--parent"
            :data-observe-anchor="'toc_lv1_' + lv1_info.name[0] + lv1_idx"
            :class="{ 'navigation-indicator': lv1_idx === 0 }"
          >
            <b-link
              class="nav-anchor text-keep-all text-decoration-none"
              @click="scroll_to_title('toc_lv1_' + lv1_idx)"
            >
              <span v-show="lang === 'KOR'">{{ lv1_info.name }}</span>
              <span v-show="lang === 'ENG'">{{
                lv1_info.name_em ? lv1_info.name_em : lv1_info.name_ea
              }}</span>
            </b-link>
          </h5>
        </div>

        <h6
          v-for="(lv2_info, lv2_idx) in lv1_info.children"
          :key="'toc_lv2_' + lv2_idx"
          :class="['nav-title nav-title--child', 'mb-0', 'ml-3']"
          :data-observe-anchor="'toc_lv2_' + lv1_idx + lv2_idx"
        >
          <div v-if="lv2_info.children.length > 0">
            <b-link
              class="nav-anchor text-keep-all text-decoration-none"
              @click="scroll_to_title('toc_lv2_' + lv1_idx + lv2_idx)"
            >
              <span v-show="lang === 'KOR'">
                {{ lv2_info.name }}
              </span>
              <span v-show="lang === 'ENG'">{{
                lv2_info.name_em ? lv2_info.name_em : lv2_info.name_ea
              }}</span>
            </b-link>
          </div>
        </h6>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'DCTocViewer',
  computed: {
    ...mapGetters('report_list', ['selected_report']),
    ...mapState('charts', ['toc_list']),
    ...mapState('report_list', ['lang']),
    anchorList() {
      return this.toc_list.reduce((_anchors, lv1_info, lv1_idx) => {
        if (lv1_info) {
          _anchors.push(`#toc_lv1_${lv1_idx}`);
        }

        if (lv1_info.children && lv1_info.children.length > 0) {
          lv1_info.children.forEach((lv2_info, lv2_idx) => {
            if (lv2_info.children && lv2_info.children.length > 0) {
              _anchors.push(`#toc_lv2_${lv1_idx}${lv2_idx}`);
            }
          });
        }
        return _anchors;
      }, []);
    }
  },
  mounted() {
    setTimeout(() => {
      this.anchorObserver = new IntersectionObserver(this.handlerObserveAnchor, {
        rootMargin: '0% 0% -78.5% 0%',
        threshold: 0.1
      });
      this.anchorList.forEach(_anchor => {
        const _anchorTitle = document.querySelector(_anchor);
        if (_anchorTitle) {
          this.anchorObserver.observe(_anchorTitle);
        }
      });
      const initialNav = document.querySelector('.navigation-indicator');
      if (initialNav) {
        initialNav.style.color = this.selected_report.main_color;
        initialNav.style.borderLeft = `4px solid ${this.selected_report.main_color}`;
      }
    }, 400);
  },
  data() {
    return {
      activatedAnchor: null,
      anchorObserver: null
    };
  },
  methods: {
    handlerObserveAnchor(entries) {
      if (entries.length) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const _navToAnchor = document.querySelectorAll(
              `[data-observe-anchor="${entry.target.id.replace(/#/g, '')}"]`
            );
            if (_navToAnchor.length) {
              const _activedNavs = document.querySelectorAll('.navigation-indicator');
              if (_activedNavs.length) {
                _activedNavs.forEach(_activedNav => {
                  _activedNav.classList.remove('navigation-indicator');
                  _activedNav.style.color = '';
                  _activedNav.style.borderLeft = '';
                });
              }
              this.activatedAnchor = entry.target.id.replace(/#/g, '');
              _navToAnchor[0].childNodes[0].classList.add('navigation-indicator');
              _navToAnchor[0].childNodes[0].style.color = this.selected_report.main_color;
              _navToAnchor[0].childNodes[0].style.borderLeft = `4px solid ${this.selected_report.main_color}`;
            }
          }
        });
      }
    },
    scroll_to_title(link) {
      const element = document.getElementById(link);
      if (element) {
        element.style.scrollMarginTop = '100px';
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }
};
</script>

<style></style>
